"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OverdueList = void 0;
const vue_1 = require("vue");
const ant_design_vue_1 = require("ant-design-vue");
const complex_utils_1 = require("complex-utils");
const complex_plugin_1 = require("complex-plugin");
const complex_data_1 = require("complex-data");
const overdue_1 = __importDefault(require("@/pages/index/api/overdue"));
const dictionary_1 = require("@/config/dictionary");
const overdue_2 = require("@/pages/index/select/overdue");
const config_1 = require("@/config/dictionary/config");
const dict_1 = require("@/pages/index/select/dict");
const select_1 = require("@/pages/index/select");
const litigation_1 = require("@/pages/index/select/litigation");
class OverdueList extends complex_data_1.ComplexList {
    buildItem(postData) {
        return new Promise((resolve, reject) => {
            overdue_1.default.overdueListBuild.require(postData).then(() => {
                this.$reloadData({
                    force: true
                }).finally(() => {
                    resolve({ status: 'success' });
                });
            }).catch(err => {
                // eslint-disable-next-line no-console
                console.error(err);
                reject(err);
            });
        });
    }
    changeItem(postData, originData) {
        return new Promise((resolve, reject) => {
            postData.id = originData.id;
            overdue_1.default.overdueListChange.require(postData).then(() => {
                this.$reloadData({
                    force: true
                }).finally(() => {
                    resolve({ status: 'success' });
                });
            }).catch(err => {
                // eslint-disable-next-line no-console
                console.error(err);
                reject(err);
            });
        });
    }
    deleteItem() {
        return new Promise((resolve, reject) => {
            overdue_1.default.overdueListDelete.require(this.$module.choice.getId()).then(() => {
                this.$module.choice.$reset();
                this.$reloadData({
                    force: true
                }).finally(() => {
                    resolve({ status: 'success' });
                });
            }).catch(err => {
                // eslint-disable-next-line no-console
                console.error(err);
                reject(err);
            });
        });
    }
    exportData() {
        return new Promise((resolve, reject) => {
            overdue_1.default.overdueExport.require(Object.assign({}, this.$getSearch())).then(res => {
                if ((0, complex_utils_1.downloadFile)(res.data.data)) {
                    complex_plugin_1.notice.showMsg('导出成功！', 'success');
                }
                else {
                    complex_plugin_1.notice.showMsg('导出失败！', 'error');
                }
                resolve({ status: 'success' });
            }).catch(err => {
                // eslint-disable-next-line no-console
                console.error(err);
                reject(err);
            });
        });
    }
    assignItem(recordList, userId, type) {
        return new Promise((resolve, reject) => {
            overdue_1.default.overdueAssignUser.require({
                overdueRecordIds: recordList.map(item => item.id),
                assignPersonId: userId,
                assignType: type
            }).then(() => {
                this.$reloadData({
                    force: true
                }).finally(() => {
                    resolve({ status: 'success' });
                });
            }).catch(err => {
                // eslint-disable-next-line no-console
                console.error(err);
                reject(err);
            });
        });
    }
}
exports.OverdueList = OverdueList;
const overdueList = new OverdueList({
    name: '逾期记录',
    prop: 'overdueList',
    module: {
        pagination: true,
        choice: {},
        search: {
            module: {
                dictionary: {
                    layout: {
                        default: {
                            grid: 6,
                            label: 10,
                            content: 14
                        }
                    },
                    list: [
                        (0, dictionary_1.buildDictionaryBySelect)(dict_1.dict.business_lines_green, {
                            prop: 'itemname',
                            name: '业务线',
                            originProp: 'itemname',
                            originFrom: 'local',
                            mod: {
                                search: {
                                    $target: 'edit'
                                }
                            }
                        }, {
                            onlyLabel: true
                        }),
                        {
                            prop: 'contractNumber',
                            name: '合同号',
                            originProp: 'contractNumber',
                            originFrom: 'local',
                            mod: {
                                search: {
                                    $type: 'edit',
                                    type: 'input',
                                    option: {
                                        maxLength: 100
                                    }
                                }
                            }
                        },
                        {
                            prop: 'customerName',
                            name: '承租人',
                            originProp: 'customerName',
                            originFrom: 'local',
                            mod: {
                                search: {
                                    $type: 'edit',
                                    type: 'input',
                                    option: {
                                        maxLength: 100
                                    }
                                }
                            }
                        },
                        (0, dictionary_1.buildDictionaryBySelect)(overdue_2.overdueStatus, {
                            prop: 'overStatus',
                            name: '逾期状态',
                            originProp: 'overStatus',
                            originFrom: 'local',
                            mod: {
                                search: {
                                    $target: 'edit'
                                }
                            }
                        }),
                        {
                            prop: 'orgname',
                            name: '经销商',
                            originProp: 'orgname',
                            originFrom: 'local',
                            mod: {
                                search: {
                                    $type: 'edit',
                                    type: 'input',
                                    option: {
                                        maxLength: 100
                                    }
                                }
                            }
                        },
                        {
                            prop: 'beginMinPlanList',
                            name: '开始逾期期数',
                            originProp: 'beginMinPlanList',
                            originFrom: 'local',
                            post(value, { targetData }) {
                                if (value && value.length > 0) {
                                    targetData.endMinPlanList = value[1];
                                    return value[0];
                                }
                            },
                            mod: {
                                search: {
                                    $type: 'edit',
                                    type: 'inputNumber',
                                    multiple: true,
                                    slot: {
                                        type: 'model',
                                        render(payload) {
                                            const formData = payload.form.data;
                                            if (!formData.beginMinPlanList) {
                                                formData.beginMinPlanList = [];
                                            }
                                            return (0, vue_1.h)('div', {
                                                style: {
                                                    display: 'flex'
                                                }
                                            }, [
                                                (0, vue_1.h)(ant_design_vue_1.InputNumber, {
                                                    style: {
                                                        flex: 'auto',
                                                        width: '100%'
                                                    },
                                                    value: formData.beginMinPlanList[0],
                                                    min: 0,
                                                    max: 10000,
                                                    placeholder: '开始',
                                                    onChange(value) {
                                                        formData.beginMinPlanList[0] = value;
                                                    }
                                                }),
                                                (0, vue_1.h)('span', {
                                                    style: {
                                                        display: 'inline-block',
                                                        margin: '0 4px',
                                                        lineHeight: '30px'
                                                    }
                                                }, '-'),
                                                (0, vue_1.h)(ant_design_vue_1.FormItemRest, {}, {
                                                    default: () => (0, vue_1.h)(ant_design_vue_1.InputNumber, {
                                                        style: {
                                                            flex: 'auto',
                                                            width: '100%'
                                                        },
                                                        value: formData.beginMinPlanList[1],
                                                        min: formData.beginMinPlanList[0] || 0,
                                                        max: 10000,
                                                        placeholder: '结束',
                                                        onChange(value) {
                                                            formData.beginMinPlanList[1] = value;
                                                        }
                                                    })
                                                }),
                                            ]);
                                        }
                                    }
                                }
                            }
                        },
                        {
                            prop: 'maxDayBegin',
                            name: '逾期天数',
                            originProp: 'maxDayBegin',
                            originFrom: 'local',
                            post(value, { targetData }) {
                                if (value && value.length > 0) {
                                    targetData.maxDayEnd = value[1];
                                    return value[0];
                                }
                            },
                            mod: {
                                search: {
                                    $type: 'edit',
                                    type: 'inputNumber',
                                    multiple: true,
                                    slot: {
                                        type: 'model',
                                        render(payload) {
                                            const formData = payload.form.data;
                                            if (!formData.maxDayBegin) {
                                                formData.maxDayBegin = [];
                                            }
                                            return (0, vue_1.h)('div', {
                                                style: {
                                                    display: 'flex'
                                                }
                                            }, [
                                                (0, vue_1.h)(ant_design_vue_1.InputNumber, {
                                                    style: {
                                                        flex: 'auto',
                                                        width: '100%'
                                                    },
                                                    value: formData.maxDayBegin[0],
                                                    min: 0,
                                                    max: 10000,
                                                    placeholder: '开始',
                                                    onChange(value) {
                                                        formData.maxDayBegin[0] = value;
                                                    }
                                                }),
                                                (0, vue_1.h)('span', {
                                                    style: {
                                                        display: 'inline-block',
                                                        margin: '0 4px',
                                                        lineHeight: '30px'
                                                    }
                                                }, '-'),
                                                (0, vue_1.h)(ant_design_vue_1.FormItemRest, {}, {
                                                    default: () => (0, vue_1.h)(ant_design_vue_1.InputNumber, {
                                                        style: {
                                                            flex: 'auto',
                                                            width: '100%'
                                                        },
                                                        value: formData.maxDayBegin[1],
                                                        min: formData.maxDayBegin[0] || 0,
                                                        max: 10000,
                                                        placeholder: '结束',
                                                        onChange(value) {
                                                            formData.maxDayBegin[1] = value;
                                                        }
                                                    })
                                                }),
                                            ]);
                                        }
                                    }
                                }
                            }
                        },
                        {
                            prop: 'isfilearchived',
                            name: '是否归档',
                            originProp: 'isfilearchived',
                            originFrom: 'local',
                            mod: {
                                search: {
                                    $type: 'edit',
                                    type: 'select',
                                    option: {
                                        list: [
                                            {
                                                value: '否',
                                                label: '否'
                                            },
                                            {
                                                value: '是',
                                                label: '是'
                                            }
                                        ]
                                    }
                                }
                            }
                        },
                        (0, dictionary_1.buildDictionaryBySelect)(overdue_2.overdueLevel, {
                            prop: 'overdueRank',
                            name: '逾期级别',
                            originProp: 'overdueRank',
                            originFrom: 'local',
                            mod: {
                                search: {
                                    $target: 'edit'
                                }
                            }
                        }),
                        {
                            prop: 'vinNo',
                            name: '车架号',
                            originProp: 'vinNo',
                            originFrom: 'local',
                            mod: {
                                search: {
                                    $type: 'edit',
                                    type: 'input'
                                }
                            }
                        },
                        (0, dictionary_1.buildDictionaryBySelect)(overdue_2.vehicleStatus, {
                            prop: 'vehicleStatus',
                            name: '车辆状态',
                            originProp: 'vehicleStatus',
                            originFrom: 'local',
                            mod: {
                                search: {
                                    $target: 'edit'
                                }
                            }
                        }),
                        {
                            prop: 'assign1PersonName',
                            name: '电催人员',
                            originProp: 'assign1PersonName',
                            originFrom: 'local',
                            mod: {
                                search: {
                                    $type: 'edit',
                                    type: 'input'
                                }
                            }
                        },
                        {
                            prop: 'assign2PersonName',
                            name: '上门人员',
                            originProp: 'assign2PersonName',
                            originFrom: 'local',
                            mod: {
                                search: {
                                    $type: 'edit',
                                    type: 'input'
                                }
                            }
                        },
                        {
                            prop: 'overSpecialSituation1',
                            name: '特殊情况1',
                            originProp: 'overSpecialSituation1',
                            originFrom: 'local',
                            mod: {
                                search: {
                                    $type: 'edit',
                                    type: 'input'
                                }
                            }
                        },
                        {
                            prop: 'overSpecialSituation2',
                            name: '特殊情况2',
                            originProp: 'overSpecialSituation2',
                            originFrom: 'local',
                            mod: {
                                search: {
                                    $type: 'edit',
                                    type: 'input'
                                }
                            }
                        },
                        (0, dictionary_1.buildDictionaryBySelect)(select_1.areaRegion, {
                            prop: 'orgAssignRuleAreaId',
                            name: '区域',
                            originProp: 'orgAssignRuleAreaId',
                            mod: {
                                search: {
                                    $target: 'edit'
                                }
                            }
                        })
                    ]
                }
            },
            menu: {
                list: []
            },
        },
        dictionary: {
            layout: {
                default: {
                    grid: 24,
                    label: 7,
                    content: 17
                }
            },
            option: {},
            propData: {
                id: 'id'
            },
            list: [
                {
                    prop: 'menu',
                    name: '操作',
                    originProp: 'menu',
                    originFrom: 'local',
                    mod: {
                        list: {
                            width: config_1.listWidth.getWidth(11),
                            local: {
                                fixed: 'left'
                            },
                        }
                    }
                },
                {
                    prop: 'id',
                    name: 'ID',
                    originProp: 'id',
                    originFrom: 'list',
                    mod: {}
                },
                {
                    prop: 'contractId',
                    name: '合同ID',
                    originProp: 'contractId',
                    originFrom: 'list',
                    mod: {}
                },
                {
                    prop: 'projectId',
                    name: '项目ID',
                    originProp: 'projectId',
                    originFrom: 'list',
                    mod: {}
                },
                {
                    prop: 'contractNumber',
                    name: '合同号',
                    originProp: 'contractNumber',
                    originFrom: 'list',
                    mod: {
                        list: {
                            width: config_1.listWidth.contractNumber,
                            local: {
                                fixed: 'left'
                            },
                            render(payload) {
                                return (0, vue_1.h)('span', {
                                    class: 'local-main-link',
                                    onClick() {
                                        overdueList.$triggerLife('menu', 'info', payload.record);
                                    }
                                }, payload.text);
                            }
                        }
                    }
                },
                {
                    prop: 'customerid',
                    name: '承租人ID',
                    originProp: 'customerid',
                    originFrom: 'list',
                    mod: {}
                },
                {
                    prop: 'customerName',
                    name: '承租人',
                    originProp: 'customerName',
                    originFrom: 'list',
                    mod: {
                        list: {
                            width: config_1.listWidth.personnelName
                        }
                    }
                },
                {
                    prop: 'mobile',
                    name: '联系电话',
                    originProp: 'mobile',
                    originFrom: 'list',
                    mod: {
                        list: {
                            width: config_1.listWidth.time
                        }
                    }
                },
                {
                    prop: 'collectionRecordContent',
                    name: '催收记录',
                    originProp: 'collectionRecordContent',
                    originFrom: 'list',
                    mod: {
                        list: {
                            width: config_1.listWidth.getWidth(11)
                        }
                    }
                },
                {
                    prop: 'collectionRecordTime',
                    name: '催收记录登记时间',
                    originProp: 'collectionRecordTime',
                    originFrom: 'list',
                    mod: {
                        list: {
                            width: config_1.listWidth.time
                        }
                    }
                },
                {
                    prop: 'totalRent',
                    name: '融资本金+利息？',
                    originProp: 'totalRent',
                    originFrom: 'list',
                    mod: {}
                },
                {
                    prop: 'rentOver',
                    name: '逾期租金',
                    originProp: 'rentOver',
                    originFrom: 'list',
                    mod: {
                        list: {
                            width: 110
                        }
                    }
                },
                {
                    prop: 'overdueRecordCount',
                    name: 'overdueRecordCount(逾期次数？-短信模板引用)',
                    originFrom: 'list',
                    mod: {}
                },
                {
                    prop: 'penaltyOver',
                    name: '逾期罚息',
                    originProp: 'penaltyOver',
                    originFrom: 'list',
                    mod: {
                        list: {
                            width: 110
                        }
                    }
                },
                {
                    prop: 'total',
                    name: '逾期总额',
                    originProp: 'total',
                    originFrom: 'list',
                    mod: {
                        list: {
                            width: 110
                        }
                    }
                },
                {
                    prop: 'residueRent',
                    name: '剩余租金',
                    originProp: 'residueRent',
                    originFrom: 'list',
                    mod: {
                        list: {
                            width: 110
                        }
                    }
                },
                (0, dictionary_1.buildDictionaryBySelect)(overdue_2.overdueLevel, {
                    prop: 'overdueRank',
                    name: '逾期级别',
                    originProp: 'overdueRank',
                    originFrom: 'list',
                    mod: {
                        list: {}
                    }
                }, {
                    color: 'background'
                }),
                {
                    prop: 'minPlanList',
                    name: '开始逾期期数',
                    originProp: 'minPlanList',
                    originFrom: 'list',
                    mod: {
                        list: {
                            width: config_1.listWidth.getWidth(6)
                        }
                    }
                },
                {
                    prop: 'maxDay',
                    name: '逾期天数',
                    originProp: 'maxDay',
                    originFrom: 'list',
                    mod: {
                        list: {
                            width: config_1.listWidth.getWidth(4)
                        }
                    }
                },
                {
                    prop: 'cumulativeMaxDay',
                    name: '累计逾期天数',
                    originFrom: 'list',
                    mod: {
                        list: {
                            width: config_1.listWidth.getWidth(6)
                        }
                    }
                },
                {
                    prop: 'cumulativeTotalRent',
                    name: '累计逾期租金',
                    originFrom: 'list',
                    mod: {
                        list: {
                            width: config_1.listWidth.getWidth(6)
                        }
                    }
                },
                {
                    prop: 'cumulativePenaltyOver',
                    name: '累计逾期罚息',
                    originFrom: 'list',
                    mod: {
                        list: {
                            width: config_1.listWidth.getWidth(6)
                        }
                    }
                },
                {
                    prop: 'cumulativeTotal',
                    name: '累计逾期总额',
                    originFrom: 'list',
                    mod: {
                        list: {
                            width: config_1.listWidth.getWidth(6)
                        }
                    }
                },
                {
                    prop: 'lastRepaymentTime',
                    name: '最后还款时间',
                    originProp: 'lastRepaymentTime',
                    originFrom: 'list',
                    mod: {
                        list: {
                            width: config_1.listWidth.getWidth(6)
                        }
                    }
                },
                {
                    prop: 'lastRepaymentAmount',
                    name: '最后还款金额',
                    originProp: 'lastRepaymentAmount',
                    originFrom: 'list',
                    mod: {
                        list: {
                            width: config_1.listWidth.getWidth(6)
                        }
                    }
                },
                {
                    prop: 'vinNo',
                    name: '车架号',
                    originProp: 'vinNo',
                    originFrom: 'list',
                    mod: {
                        list: {
                            width: config_1.listWidth.vin
                        }
                    }
                },
                {
                    prop: 'licensePlateNumber',
                    name: '车牌号',
                    originProp: 'licensePlateNumber',
                    originFrom: 'list',
                    mod: {
                        list: {
                            width: config_1.listWidth.getWidth(8)
                        }
                    }
                },
                {
                    prop: 'engineNo',
                    name: '发动机编号',
                    originProp: 'engineNo',
                    originFrom: 'list',
                    mod: {
                        list: {
                            width: config_1.listWidth.vehicleEngineNo
                        }
                    }
                },
                {
                    prop: 'assign1PersonName',
                    name: '电催人员',
                    originProp: 'assign1PersonName',
                    originFrom: 'list',
                    mod: {
                        list: {
                            width: config_1.listWidth.personnelName
                        }
                    }
                },
                {
                    prop: 'assign1PersonTime',
                    name: '电催分派时间',
                    originProp: 'assign1PersonTime',
                    originFrom: 'list',
                    mod: {
                        list: {
                            width: config_1.listWidth.time
                        }
                    }
                },
                {
                    prop: 'assign2PersonName',
                    name: '上门人员',
                    originProp: 'assign2PersonName',
                    originFrom: 'list',
                    mod: {
                        list: {
                            width: config_1.listWidth.personnelName
                        }
                    }
                },
                {
                    prop: 'assign2PersonTime',
                    name: '上门分派时间',
                    originProp: 'assign2PersonTime',
                    originFrom: 'list',
                    mod: {
                        list: {
                            width: config_1.listWidth.time
                        }
                    }
                },
                {
                    prop: 'vehicleLastTime',
                    name: '车辆离线时间',
                    format(value) {
                        if (value) {
                            const lastTime = new Date(value);
                            const currentDate = complex_plugin_1.date.getData('data');
                            const one = 24 * 60 * 60 * 1000;
                            return (0, complex_utils_1.getNum)((currentDate.getTime() - lastTime.getTime()) / one, 'round', 1);
                        }
                    },
                    originProp: 'vehicleLastTime',
                    originFrom: 'list',
                    mod: {
                        list: {
                            width: config_1.listWidth.getWidth(6)
                        }
                    }
                },
                {
                    prop: 'brandname',
                    name: '车辆品牌',
                    originProp: 'brandname',
                    originFrom: 'list',
                    mod: {
                        list: {
                            width: config_1.listWidth.getWidth(5)
                        }
                    }
                },
                {
                    prop: 'seriesname',
                    name: '车系',
                    originProp: 'seriesname',
                    originFrom: 'list',
                    mod: {
                        list: {
                            width: config_1.listWidth.getWidth(4, 0, 1)
                        }
                    }
                },
                {
                    prop: 'orgCustomerid',
                    name: '经销商ID',
                    originProp: 'orgCustomerid',
                    originFrom: 'list',
                    mod: {}
                },
                {
                    prop: 'orgname',
                    name: '经销商',
                    originProp: 'orgname',
                    originFrom: 'list',
                    mod: {
                        list: {
                            width: 240
                        }
                    }
                },
                {
                    prop: 'productName',
                    name: '产品名称',
                    originProp: 'productName',
                    originFrom: 'list',
                    mod: {
                        list: {
                            width: config_1.listWidth.getWidth(12)
                        }
                    }
                },
                {
                    prop: 'overSpecialSituation1',
                    name: '特殊情况1',
                    originProp: 'overSpecialSituation1',
                    originFrom: 'list',
                    mod: {
                        list: {
                            width: config_1.listWidth.getWidth(10)
                        }
                    }
                },
                {
                    prop: 'overSpecialSituation2',
                    name: '特殊情况2',
                    originProp: 'overSpecialSituation2',
                    originFrom: 'list',
                    mod: {
                        list: {
                            width: config_1.listWidth.getWidth(10)
                        }
                    }
                },
                {
                    prop: 'keepInStorageFlag',
                    name: '是否保全入库',
                    originProp: 'keepInStorageFlag',
                    originFrom: 'list',
                    mod: {}
                },
                {
                    prop: 'itemname',
                    name: '业务线',
                    originProp: 'itemname',
                    originFrom: 'list',
                    mod: {
                        list: {
                            width: config_1.listWidth.businessLine
                        }
                    }
                },
                (0, dictionary_1.buildDictionaryBySelect)(select_1.areaRegion, {
                    prop: 'orgAssignRuleAreaId',
                    name: '区域',
                    originProp: 'orgAssignRuleAreaId',
                    mod: {
                        list: {}
                    }
                }),
                {
                    prop: 'cleanLeaseMoney',
                    name: '融资总额',
                    originProp: 'cleanLeaseMoney',
                    originFrom: 'list',
                    mod: {
                        list: {
                            width: 100
                        }
                    }
                },
                {
                    prop: 'incomeNumber',
                    name: '融资期数',
                    originProp: 'incomeNumber',
                    originFrom: 'list',
                    mod: {
                        list: {
                            width: config_1.listWidth.getWidth(4)
                        }
                    }
                },
                {
                    prop: 'isfilearchived',
                    name: '归档',
                    originProp: 'isfilearchived',
                    originFrom: 'list',
                    mod: {
                        list: {
                            width: config_1.listWidth.getWidth(2)
                        }
                    }
                },
                (0, dictionary_1.buildDictionaryBySelect)(overdue_2.contractStatus, {
                    prop: 'contractStatus',
                    name: '合同状态',
                    originProp: 'contractStatus',
                    originFrom: 'list',
                    mod: {
                        list: {}
                    }
                }),
                (0, dictionary_1.buildDictionaryBySelect)(overdue_2.vehicleStatus, {
                    prop: 'vehicleStatus',
                    name: '车辆状态',
                    originProp: 'vehicleStatus',
                    originFrom: 'list',
                    mod: {
                        list: {}
                    }
                }),
                (0, dictionary_1.buildDictionaryBySelect)(overdue_2.overdueStatus, {
                    prop: 'overStatus',
                    name: '逾期状态',
                    originProp: 'overStatus',
                    originFrom: 'list',
                    mod: {
                        list: {}
                    }
                }),
                {
                    prop: 'residueCorpus',
                    name: '剩余本金',
                    originProp: 'residueCorpus',
                    originFrom: 'list',
                    mod: {
                        list: {
                            width: 110
                        }
                    }
                },
                {
                    prop: 'residueInterest',
                    name: '剩余利息',
                    originProp: 'residueInterest',
                    originFrom: 'list',
                    mod: {
                        list: {
                            width: 110
                        }
                    }
                },
                {
                    prop: 'alreadyRepaymentNum',
                    name: '已还期数',
                    originProp: 'minPlanList',
                    originFrom: 'list',
                    format(value) {
                        return value - 1;
                    },
                    mod: {
                        list: {
                            width: config_1.listWidth.getWidth(4)
                        }
                    }
                },
                {
                    prop: 'initPlanList',
                    name: '初始逾期期数',
                    originProp: 'initPlanList',
                    originFrom: 'list',
                    mod: {}
                },
                {
                    prop: 'numb',
                    name: '逾期期数',
                    originProp: 'numb',
                    originFrom: 'list',
                    mod: {
                        list: {
                            width: config_1.listWidth.getWidth(4)
                        }
                    }
                },
                {
                    prop: 'areaManagerId',
                    name: '区域经理ID',
                    originProp: 'areaManagerId',
                    originFrom: 'list',
                    mod: {}
                },
                {
                    prop: 'username2',
                    name: '区域经理',
                    originProp: 'username2',
                    originFrom: 'list',
                    mod: {
                        list: {
                            width: config_1.listWidth.personnelName
                        }
                    }
                },
                {
                    prop: 'areaId',
                    name: '大区ID',
                    originProp: 'areaId',
                    originFrom: 'list',
                    mod: {}
                },
                {
                    prop: 'areaName',
                    name: '大区名称',
                    originProp: 'areaName',
                    originFrom: 'list',
                    mod: {}
                },
                {
                    prop: 'certid',
                    name: '身份证号',
                    originProp: 'certid',
                    originFrom: 'list',
                    mod: {}
                },
                {
                    prop: 'collection1PersonName',
                    name: '电催更新人员',
                    originProp: 'collection1PersonName',
                    originFrom: 'list',
                    mod: {}
                },
                {
                    prop: 'collection1PersonTime',
                    name: '电催更新时间',
                    originProp: 'collection1PersonTime',
                    originFrom: 'list',
                    mod: {}
                },
                {
                    prop: 'collection2PersonName',
                    name: '上门更新人员',
                    originProp: 'collection2PersonName',
                    originFrom: 'list',
                    mod: {}
                },
                {
                    prop: 'collection2PersonTime',
                    name: '上门更新时间',
                    originProp: 'collection2PersonTime',
                    originFrom: 'list',
                    mod: {}
                },
                {
                    prop: 'spouseName',
                    name: '配偶姓名',
                    originProp: 'spouseName',
                    originFrom: 'list',
                    mod: {
                        list: {
                            width: config_1.listWidth.personnelName
                        }
                    }
                },
                {
                    prop: 'spouseMobile',
                    name: '配偶联系方式',
                    originProp: 'spouseMobile',
                    originFrom: 'list',
                    mod: {
                        list: {
                            width: config_1.listWidth.phone
                        }
                    }
                },
                {
                    prop: 'spouseCertid',
                    name: '配偶身份证',
                    originProp: 'spouseCertid',
                    originFrom: 'list',
                    mod: {}
                },
                {
                    prop: 'assureName',
                    name: '自然人担保',
                    originProp: 'assureName',
                    originFrom: 'list',
                    mod: {
                        list: {
                            width: config_1.listWidth.personnelName
                        }
                    }
                },
                {
                    prop: 'assurePhone',
                    name: '自然人担保电话',
                    originProp: 'assurePhone',
                    originFrom: 'list',
                    mod: {
                        list: {
                            width: config_1.listWidth.phone
                        }
                    }
                },
                {
                    prop: 'enterprisename',
                    name: '法人担保',
                    originProp: 'enterprisename',
                    originFrom: 'list',
                    mod: {
                        list: {
                            width: config_1.listWidth.getWidth(10)
                        }
                    }
                },
                {
                    prop: 'affiliatedName',
                    name: '挂靠方名称',
                    originProp: 'affiliatedName',
                    originFrom: 'list',
                    mod: {
                        list: {
                            width: config_1.listWidth.getWidth(10)
                        }
                    }
                },
                {
                    prop: 'rent',
                    name: '月租金',
                    originProp: 'rent',
                    originFrom: 'list',
                    mod: {}
                },
                {
                    prop: 'factRent',
                    name: '已还金额',
                    originProp: 'factRent',
                    originFrom: 'list',
                    mod: {}
                },
                {
                    prop: 'loanTime',
                    name: ' 放款时间',
                    originProp: 'loanTime',
                    originFrom: 'list',
                    mod: {
                        list: {
                            width: config_1.listWidth.date
                        }
                    }
                },
                {
                    prop: 'contractEndTime',
                    name: '合同结束时间',
                    originProp: 'contractEndTime',
                    originFrom: 'list',
                    mod: {}
                },
                {
                    prop: 'overdueProject',
                    name: '逾期专项',
                    originProp: 'overdueProject',
                    originFrom: 'list',
                    mod: {
                        list: {
                            width: config_1.listWidth.date
                        }
                    }
                },
                {
                    prop: 'vehicleDisposal',
                    name: '车辆处置',
                    originProp: 'vehicleDisposal',
                    originFrom: 'list',
                    mod: {
                        list: {
                            width: config_1.listWidth.date
                        }
                    }
                },
                {
                    prop: 'dealerGuaranteePeriod',
                    name: '担保期数',
                    originFrom: 'list',
                    mod: {
                        list: {
                            width: config_1.listWidth.getWidth(4)
                        }
                    }
                },
                {
                    prop: 'dealerGuaranteeFlag',
                    name: '是否担保',
                    originFrom: 'list',
                    mod: {
                        list: {
                            width: config_1.listWidth.getWidth(4)
                        }
                    }
                },
                {
                    prop: 'dealerRemainGuaranteePeriod',
                    name: '担保剩余期数',
                    originFrom: 'list',
                    mod: {
                        list: {
                            width: config_1.listWidth.getWidth(6)
                        }
                    }
                },
                // {
                //   prop: 'alreadyRepaidNumber',
                //   name: '已还期数',
                //   originFrom: 'list',
                //   mod: {
                //     list: {
                //       width: listWidth.getWidth(4)
                //     }
                //   }
                // },
                {
                    prop: 'crOverReason',
                    name: '逾期原因',
                    originFrom: 'list',
                    mod: {
                        list: {
                            width: config_1.listWidth.getWidth(8)
                        }
                    }
                },
                {
                    prop: 'crOverReasonRemark',
                    name: '逾期类型',
                    originFrom: 'list',
                    mod: {
                        list: {
                            width: config_1.listWidth.getWidth(8)
                        }
                    }
                },
                (0, dictionary_1.buildDictionaryBySelect)(dict_1.dict.LITIGATION_TYPE, {
                    prop: 'litigationType',
                    name: '诉讼类型',
                    originProp: 'litigationType',
                    mod: {
                        list: {}
                    }
                }),
                (0, dictionary_1.buildDictionaryBySelect)(litigation_1.logStatus, {
                    prop: 'litigationStatus',
                    name: '诉讼状态',
                    originProp: 'litigationStatus',
                    mod: {
                        list: {}
                    }
                }),
                {
                    prop: 'syncTime',
                    name: '更新时间',
                    originProp: 'syncTime',
                    originFrom: 'list',
                    mod: {}
                },
                {
                    prop: 'remark',
                    name: '备注',
                    originProp: 'remark',
                    originFrom: 'list',
                    mod: {}
                },
                {
                    prop: 'isDeleted',
                    name: '无',
                    originProp: 'isDeleted',
                    originFrom: 'list',
                    mod: {}
                },
                {
                    prop: 'enableFlag',
                    name: '无',
                    originProp: 'enableFlag',
                    originFrom: 'list',
                    mod: {}
                },
                {
                    prop: 'createdBy',
                    name: '创建人id',
                    originProp: 'createdBy',
                    originFrom: 'list',
                    mod: {}
                },
                {
                    prop: 'createdTime',
                    name: '创建时间',
                    originProp: 'createdTime',
                    originFrom: 'list',
                    mod: {}
                },
                {
                    prop: 'updatedBy',
                    name: '更新人',
                    originProp: 'updatedBy',
                    originFrom: 'list',
                    mod: {}
                },
                {
                    prop: 'updatedTime',
                    name: '更新时间',
                    originProp: 'updatedTime',
                    originFrom: 'list',
                    mod: {}
                },
            ]
        }
    },
    $getData() {
        return new Promise((resolve, reject) => {
            overdue_1.default.overdueList.require(Object.assign(Object.assign({}, this.$getSearch()), { pageNo: this.$getPageData('current'), pageSize: this.$getPageData('size') })).then(res => {
                this.$formatList(res.data.data, res.data.totalCount);
                resolve({ status: 'success' });
            }).catch(err => {
                // eslint-disable-next-line no-console
                console.error(err);
                reject(err);
            });
        });
    }
});
exports.default = overdueList;
